<template>
    <div class="cat_conter" :id="'option'+idx">
        <div class="conter_top">
            <div class="testpaper-question-tit-wrap">
                <div class="testpaper-question-tit">{{idx+1}}</div>
                <div class="testpaper-question-score">{{parentData.topic_score}}.0分</div>
            </div>
            <div class="testpaper-question-topic clearfix">
                <div v-html="strcharacterDiscode(parentData.topic_stem)"></div>
                <br />
            </div>
        </div>
        <ul class="testpaper-question-choices">
            <li @click="truefalseData(1,parentData.topic_id,idx)">
                <span :class = '{active:isactive===1}' class="testpaper-question-choice-index" >A</span>
                <p>正确</p>
            </li>
             <li @click="truefalseData(0,parentData.topic_id,idx)">
                <span :class = '{active:isactive===0}' class="testpaper-question-choice-index" >B</span>
                <p>错误</p>
            </li>
        </ul>
    </div>
</template>

<script>
    import strcharacterDiscode from '@/js/strcharacterDiscode'
    export default {
        props:['parentData','idx'],
        data(){
            return {
                option: ['A','B','C','D','E','F','G','H','I','J'],
                isactive : -1,
                selectIndex: []
            }
        },
        created() {
            
        },
        methods: {
            truefalseData(index,key,idx) {
                this.isactive=index;
                this.$emit('truefalseData',[index,key])
                if(this.isactive!=-1){
                    document.querySelector("#card"+idx).className="active";
                }
                let returnEle = document.querySelector("#option"+(idx+1));
                !!returnEle && returnEle.scrollIntoView(true);
            },
            strcharacterDiscode
        }
    }
</script>

<style scoped>
    .testpaper-question-tit-wrap{
        float: left;
        margin-right: 10px;
    }
    .testpaper-question-tit-wrap{
        text-align: center;
    }
    .testpaper-question-tit{
        font-size: 20px;
        color: #3a87ad;
    }
    .testpaper-question-score {
        font-size: 12px;
        color: #aaa;
        border: 1px solid #ccc;
        padding: 0 1px;
        border-radius: 5px;
        background: #f6f6f6;
        display: inline-block;
    }
    .testpaper-question-topic {
        border-bottom: 1px dashed #ddd;
        margin-bottom: 10px;
        overflow: hidden;
        zoom: 1;
    }
    .active{
        background: rgb(105, 153, 117);
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/TrueFalse.vue